<template>
  <div class="content-wrap" :style="getContentWrapStyle()">
    <BaseSearchbar
      v-if="toolbar"
      ref="toolbar"
      v-model="searchData"
      v-bind="toolbar"
    ></BaseSearchbar>
    <BasePath
      v-if="basepath"
      ref="basepath"
      v-model="basepath.value"
      v-bind="basepath.bind"
      v-on="basepath.on"
    ></BasePath>
    <div class="table-wrap" :style="getTableWrapStyle()">
      <el-table
        ref="table"
        v-if="tableShow"
        :data="rows"
        height="100%"
        v-loading="loading"
        element-loading-text="拼命加载中"
        v-loadmore="loadmore"
        :border="true"
        :resizable="true"
      >
        <el-table-column
          v-for="(col, index) in columns"
          :key="index"
          v-bind="col.bind"
          show-overflow-tooltip
        >
          <template #header="scope">
            <component
              v-if="col.header && col.header.component"
              :is="$getComponent(col.header.component, scope)"
              v-bind="col.header.bind"
              v-on="col.header.on"
              :scope="scope"
            ></component>
            <span v-else>{{ scope.column.label }}</span>
          </template>
          <template #default="scope">
            <component
              v-if="col.default && col.default.component"
              :is="$getComponent(col.default.component, scope)"
              v-bind="col.default.bind"
              v-on="col.default.on"
              :scope="scope"
            ></component>
            <span v-else v-text="defaultCell(scope, col.format)"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showPagination" class="pagination">
      <el-pagination
        style="text-align: right"
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="query.PageIndex"
        :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
        :page-size="query.PageSize"
        layout="total, sizes, prev, jumper, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// import BaseSearchbar from './BaseSearchbar.vue'
// import BasePath from './BasePath.vue'
export default {
  name: 'base-table-new',
  props: {
    toolbar: Object,
    basepath: Object,
    url: String,
    delUrl: String,
    columns: Array,
    rules: Array,
    sendJson: Boolean,
    responseHandler: Function,
    initSearch: {
      //初始化后执行查询操作
      type: Boolean,
      default: true,
    },
    // showRefreshBtn:{//是否显示刷新按钮 默认显示
    // 	type: Boolean,
    // 	default: true
    // },
    showPagination: {
      type: Boolean,
      default: true,
    },
    isSendToken: {
      type: Boolean,
      default: true,
    },
    query: {
      type: Object,
      default() {
        return {
          PageIndex: 1, //PageIndex 一定要大写
          PageSize: 30, //PageSize 一定要大写
        }
      },
    },
  },
  components: {
    // BaseSearchbar,
    // BasePath
  },
  directives: {
    loadmore: {
      // 指令的定义
      bind: function (el, binding, vnode) {
        var selectWrap = el.querySelector('.el-table__body-wrapper')
        vnode.context.loadmore_delay = true
        if (!vnode.context.showPagination) {
          setTimeout(() => {
            vnode.context.getNewData()
          }, 50)
        }

        // selectWrap.addEventListener('scroll', function () {
        //     var sign = 100
        //     var scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
        //     if (vnode.context.loadmore_delay && scrollDistance <= sign) {
        //         vnode.context.loadmore_delay = false;
        //         // new Promise(binding.value)
        //         //     .then(function () {
        //         //         vnode.context.loadmore_delay = true;
        //         //     });
        //         //binding.value();
        //         // console.log('距离底部小于100了')
        //         // console.log(vnode.context)
        // 		// // 指令中不能用this关键字
        // 		vnode.context.query.PageIndex++;
        //         vnode.context.getNewData();
        //     }
        // })
      },
    },
  },
  created() {
    if (!this.query.PageIndex) {
      this.$set(this.query, 'PageIndex', 1)
    }
    if (!this.query.PageSize) {
      this.$set(this.query, 'PageSize', 30)
    }

    if (this.toolbar) {
      if (!this.toolbar.buttons) {
        this.toolbar.buttons = [
          {
            label: '查询',
            on: { click: this.tableSearch },
            bind: { icon: 'el-icon-search', type: 'primary' },
          },
          {
            label: '重置',
            on: { click: this.tableSearchReset },
            bind: { icon: 'el-icon-refresh-left' },
          },
        ]

        //额外的button
        if (Array.isArray(this.toolbar.exButtons)) {
          for (var i = 0; i < this.toolbar.exButtons.length; i++) {
            this.toolbar.buttons.push(this.toolbar.exButtons[i])
          }

          //this.toolbar.buttons=this.toolbar.buttons.concat(this.toolbar.exButtons);
        }
      }

      if (this.toolbar.query) {
        //Object.assign(this.query, this.toolbar.query);
        // if (!this.toolbar.query.PageIndex) this.toolbar.query.PageIndex = 1
        // if (!this.toolbar.query.PageSize) this.toolbar.query.PageSize = 30
        for (var key in this.toolbar.query) {
          this.query[key] = this.toolbar.query[key]
        }
        // this.query = this.toolbar.query
      }
    }

    if (this.initSearch) {
      this.refreshData()
    }
  },
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      searchData: {},
      tableShow: true,
      // query:{
      // 	PageIndex: 1,
      // 	PageSize: 30
      // }
    }
  },
  methods: {
    //刷新按钮事件
    refreshBtn() {
      var that = this
      that.$refs.toolbar.$refs.form.resetFields() //重置查询条件
      that.tableShow = false //刷新表格
      that.$nextTick(function () {
        that.tableShow = true
        that.$nextTick(function () {
          that.tableSearch()
        })
      })
    },
    getTableWrapStyle() {
      var style = {}
      if (this.basepath) {
        style.height = 'calc(100% - 14px)'
      }
      return style
    },
    getContentWrapStyle() {
      var style = {}
      if (!this.showPagination) {
        style.paddingBottom = '10px'
      }
      if (!this.toolbar) {
        style.paddingTop = '0px'
      }
      return style
    },
    defaultCell(scope, format) {
      var that = this
      if (format && typeof format == 'function') {
        return format(scope.row[scope.column.property])
      } else {
        if (scope.column.property.indexOf('.') > 0) {
          var split = scope.column.property.split('.')
          var obj = scope.row[split[0]]
          if (obj) {
            return obj[split[1]]
          }
          return ''
        } else {
          return scope.row[scope.column.property]
        }
      }
    },
    /*查询按钮事件*/
    tableSearch() {
      this.query.PageIndex = 1
      this.refreshData()
    },
    /*重置查询条件*/
    tableSearchReset() {
      this.$refs.toolbar.resetForm()
    },
    /*获取查询参数*/
    getSearchData() {
      var data = Object.assign({}, this.searchData, this.query)
      return data
    },
    getNewData() {
      var that = this
      var data = that.getSearchData()
      var paramMap = {}
      for (var prop in data) {
        var val = data[prop]
        if (val && val.indexOf && val.indexOf('ComparePattern') > 0) {
          var obj = JSON.parse(val)
          paramMap[prop] = obj.ComparePattern
          data[prop] = obj.Values[0]
        }
      }
      data.paramMatchMap = paramMap
      that
        .$post(
          that.url,
          data,
          (data, headers) => {
            that.loading = true
          },
          function (data) {
            that.loading = false
          },
          that.isSendToken
        )
        .then((resp) => {
          if (resp.data.code == 0) {
            if (that.query.PageIndex == 1) {
              that.rows = resp.data.data.content || []
            } else {
              that.rows = that.rows.concat(resp.data.data.content)
            }
            if (that.query.PageSize == resp.data.data.content.length) {
              that.loadmore_delay = true
            }
          } else {
            alert(resp.data.msg)
          }
        })
        .catch((error) => {
          // 请求失败处理
          alert('请求发生错误！')
          console.error(error)
        })
    },
    setTableData(data) {
      if (data) {
        this.rows = data.rows || []
        this.total = data.total || 0
      }
    },
    /*刷新table数据*/
    refreshData() {
      setTimeout(() => {
        //延迟调用，因为getSearchData()的mvvm需要一段执行时间才能更新完
        var data = this.getSearchData()
        this[this.sendJson ? '$postObj' : '$post'](
          this.url,
          data,
          (data, headers) => {
            this.loading = true
          },
          (data) => {
            this.loading = false
          },
          this.isSendToken
        )
          .then((resp) => {
            if (typeof this.responseHandler == 'function') {
              this.setTableData(this.responseHandler(resp))
            } else {
              if (resp.data.code == 0) {
                this.setTableData({
                  rows: resp.data.data.Data || [],
                  total: resp.data.data.Total || 0,
                })
              } else {
                //this.$message(resp.data.msg || '服务端返回数据异常')
                console.error(resp)
              }
            }
          })
          .catch((error) => {
            // 请求失败处理
            this.loading = false
            //this.$message('请求发生错误！')
            console.error(error)
          })
      }, 50)
    },
    sizeChange(PageSize) {
      this.query.PageIndex = 1
      this.query.PageSize = PageSize
      this.refreshData()
    },
    currentChange(PageIndex) {
      this.query.PageIndex = PageIndex
      this.refreshData()
    },
    loadRows(rows) {
      this.rows = rows
    },
    delRow(row) {
      var that = this
      var index = that.rows.indexOf(row)
      if (index > -1) that.rows.splice(index, 1)
    },
    addRow(row) {
      this.rows.unshift(row)
    },
    updRow(oldRow, newRow) {
      for (var key in oldRow) {
        this.$set(oldRow, key, newRow[key])
      }
    },
    loadmore(resolve, reject) {
      this.$emit('on-loadmore', resolve, reject)
    },
  },
}
</script>

<style>
.content-wrap {
  padding: 62px 10px 52px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
	border-radius: 2px;
	overflow: hidden; */
}

.table-wrap {
  height: 100%;
}
.pagination {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// packages/BaseTable.vue